/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_No_Presets_TextInputs */

const en_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a subtitle export preset before running a batch export.`)
};

const fr_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un préréglage d'exportation des sous-titres avant d'exécuter une exportation par lots.`)
};

const de_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie vor dem Ausführen eines Stapelexports eine Untertitel-Exportvorgabe.`)
};

const it_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima di avviare un'esportazione in batch, crea un preset per l'esportazione dei sottotitoli.`)
};

const ru_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перед запуском пакетного экспорта создайте предустановленные параметры экспорта субтитров.`)
};

const es_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree un ajuste predefinido para la exportación de subtítulos antes de ejecutar una exportación por lotes.`)
};

const zh_cn2_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在运行批量导出之前，创建字幕导出预设。`)
};

const ja_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチエクスポートを実行する前に、字幕エクスポートプリセットを作成してください。`)
};

const hi_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच एक्सपोर्ट चलाने से पहले सबटाइटल एक्सपोर्ट प्रीसेट बनाएं।`)
};

const pt_pt2_explorer_info_batch_no_presets_text = /** @type {(inputs: Explorer_Info_Batch_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma predefinição de exportação de legendas antes de executar uma exportação em lote.`)
};

/**
* | output |
* | --- |
* | "Create a subtitle export preset before running a batch export." |
*
* @param {Explorer_Info_Batch_No_Presets_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_no_presets_text = /** @type {((inputs?: Explorer_Info_Batch_No_Presets_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_No_Presets_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_no_presets_text(inputs)
	if (locale === "de") return de_explorer_info_batch_no_presets_text(inputs)
	if (locale === "it") return it_explorer_info_batch_no_presets_text(inputs)
	if (locale === "ru") return ru_explorer_info_batch_no_presets_text(inputs)
	if (locale === "es") return es_explorer_info_batch_no_presets_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_no_presets_text(inputs)
	if (locale === "ja") return ja_explorer_info_batch_no_presets_text(inputs)
	if (locale === "hi") return hi_explorer_info_batch_no_presets_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_no_presets_text(inputs)
	return en_explorer_info_batch_no_presets_text(inputs)
});